import {InjectionToken, ModuleWithProviders, NgModule, Optional, SkipSelf} from "@angular/core";
import {ReportService} from "./report/report.service";

@NgModule({})
export class ResourceModule {
    /**
     * Provider application key - identifies the application in the configuration context.
     * @type {InjectionToken}
     */
    public static readonly RESOURCE_NAMESPACE_KEY: InjectionToken<string> = new InjectionToken<string>('resourceNamespace');

    /**
     * Provider entity names key - identifies the entity resources in the configuration context.
     * @type {InjectionToken}
     */
    public static readonly ENTITY_NAMES_KEY: InjectionToken<string> = new InjectionToken<string>('entityNames');

    /**
     * Provider search names key - identifies the search resources in the configuration context.
     * @type {InjectionToken}
     */
    public static readonly SEARCH_NAMES_KEY: InjectionToken<string> = new InjectionToken<string>('searchNames');

    /**
     * Provider action names key - identifies the action resources in the configuration context.
     * @type {InjectionToken}
     */
    public static readonly ACTION_NAMES_KEY: InjectionToken<string> = new InjectionToken<string>('actionNames');

    public static readonly RESOURCE_USE_ASYNC: InjectionToken<string> = new InjectionToken<string>('useAsync');

    constructor(@Optional() @SkipSelf() parentModule: ResourceModule) {
        if (parentModule) {
            throw new Error('ResourceModule is already loaded. Import it in the AppModule only');
        }
    }

    /**
     * Provide the configuration service and the application key used in the configuration context.
     * @param config
     * @return ModuleWithProviders
     */
    static forRoot(config: ResourceConfig): ModuleWithProviders<ResourceModule> {
        return {
            ngModule: ResourceModule,
            providers: [
                {provide: ResourceModule.RESOURCE_NAMESPACE_KEY, useValue: config.nameSpace},
                {provide: ResourceModule.ENTITY_NAMES_KEY, useValue: config.entityNames},
                {provide: ResourceModule.SEARCH_NAMES_KEY, useValue: config.searchNames},
                {provide: ResourceModule.ACTION_NAMES_KEY, useValue: config.actionNames},
                {provide: ResourceModule.RESOURCE_USE_ASYNC, useValue: config.useAsync},
                ReportService
            ]
        };
    }
}

export class ResourceConfig {
    nameSpace: string;
    entityNames?: string[];
    searchNames?: string[];
    actionNames?: string[];
    useAsync?: boolean;
}
